import { render, staticRenderFns } from "./RequirementDialog.vue?vue&type=template&id=774907e4&scoped=true"
import script from "./RequirementDialog.vue?vue&type=script&lang=js"
export * from "./RequirementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774907e4",
  null
  
)

export default component.exports